import {createAsyncThunk} from "@reduxjs/toolkit";

import { IOrder} from "../../../helpers/types";
import OrdersService from "../../../api/OrdersService";




export const asyncGetOrdersAction = createAsyncThunk(
    'orders/all',
    async (query:any, thunkAPI)=>{
        try {
            const {sort,page,limit,search} = query;


            let response = await OrdersService.findAll(sort,limit,page);
            return response.data;

        } catch (e:any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);


export const asyncGetOrderAction = createAsyncThunk(
    'orders/one',
    async (id:number, thunkAPI)=>{
        try {
            let response = await OrdersService.findOne(id);
            return response.data;
        } catch (e:any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);


export const asyncUpdateOrderAction = createAsyncThunk(
    'orders/update',
    async (order:IOrder, thunkAPI)=>{
        try {
            const {id,status} = order;

            let response = await OrdersService.update({status}, id as number);
            return response.data;
        } catch (e:any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);

export const asyncDeleteOrderAction = createAsyncThunk(
    'orders/delete',
    async (id:number, thunkAPI)=>{
        try {
            let response = await OrdersService.delete(id);
            return response.data;
        } catch (e:any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message)
        }
    }
);